<template>
    <div>
        <h2 class="text-2xl font-bold mb-4">
            Opt-in as an accredited investor
        </h2>
        <p class="font-bold mb-8">
            Be classified as an Accredited Investor in our platform
        </p>
        <p class="text-justify mb-3">
            You are assessed to be a person mentioned in section 4A(1)(a)(i), (ii), (iii) or (iv) of the Securities and
            Futures Act (Chapter 289) of Singapore (“SFA”) as the Accredited Investor (“Accredited Investor”).
        </p>
        <p class="text-justify mb-3">
            We draw your attention that the Accredited Investors are assumed to be better informed, and better able to
            access resources to protect their own interests, and therefore require less regulatory protection. Investors
            who agree to be treated as Accredited Investors therefore forgo the benefit of certain regulatory
            safeguards. For example, the Issuers of securities are exempted from issuing a full prospectus registered
            with the Monetary Authority of Singapore in respect of offers that are made only to Accredited Investors,
            and intermediaries are exempted from a number of business conduct requirements when dealing with Accredited
            Investors. Investors should consult a professional adviser if they do not understand any consequence of
            being treated as an Accredited Investor.
        </p>
        <p class="font-bold text-justify mb-3">
            By clicking "Agree", you provide your consent to be treated as the Accredited Investor in relations with
            Kilde Pte. Ltd., Escrow Agent and Issuers of the securities offered for the subscription on this Platform
            (“counterparties”).
        </p>
        <p class="text-justify mb-3">
            If you click "Agree" and provide your consent to be treated as the Accredited Investor by the
            counterparties, you may at any time withdraw your consent, upon which the counterparties must not treat you
            as an Accredited Investor for the purposes of this Platform.
        </p>
        <p class="text-justify mb-3">
            If you click "Agree" and provide your consent to be treated as the Accredited Investor by the
            counterparties, you confirm your awareness and understanding of the consequences of consenting to being
            treated by the counterparties as the Accredited Investor for the purposes of this Platform and your
            awareness that you may at any time withdraw your consent to be treated as the Accredited Investor given
            hereby.
        </p>
        <p class="mt-8 font-bold mb-3">
            Explanation of the effect of the consent
        </p>
        <p class="text-justify mb-3">
            To make it clear, by the provision of the consent to be treated as the Accredited Investor, you are assumed
            to be the Accredited Investor that has good knowledge and experience in investment matters. You are
            considered to be better informed for making investment decisions, risk consideration etc.
        </p>
        <p class="text-justify mb-3">
            By provision of the consent to be treated as the Accredited Investor, you will be under less regulatory
            protection. In particular, all prospectuses of the Issuers (Information Memorandums and Pricing Supplements)
            for the securities that are offered for the subscription on this Platform are exempt from the registration
            requirement with the Monetary Authority of Singapore in respect of such offers. The content of the
            prospectuses of the Issuers (Information Memorandums and Pricing Supplements) are not examined and revised
            by the Monetary Authority of Singapore. You are assumed to be the Accredited Investor that is able to
            evaluate the investments at your own and without help of the third parties.
        </p>
        <p class="text-justify mb-3">
            If you are not sure that you are in compliance with the definition of the Accredited Investors and/or you do
            not understand the legal effect of being treated as the Accredited Investor, do not click "Agree" and
            contact your professional advisors for receiving additional information about the effect of being treated as
            the Accredited Investor by the counterparties.
        </p>
    </div>
</template>


<script>
export default {}
</script>
